<template>
  <div class="cooperaionPage">
    <!-- banner -->
    <div class="banner">
      <img
        src="https://upload.vwingist.com/melscn/0image/2025/02/4814452218230564617.png"
        alt=""
      />
    </div>

    <div class="main-content">
      <h1 class="main-title">
        品質，穿越週期的船票<br />
        VESCOR以敬畏之心，雕琢每一寸肌膚的期待。
      </h1>
      <p class="txt">
        從瑞士阿爾卑斯山的原料秘境，到精密儀器屏息的實驗室，自然與科技在瓶中共鳴。這不僅是一場護膚革命，更是肌膚煥新的哲學實踐。
      </p>
      <div class="img-box image-container">
        <img
          src="https://upload.vwingist.com/melscn/0image/2025/04/5411577449100158900.jpeg"
          alt=""
          class="zoomable-image"
        />
      </div>
      <p class="txt">
        科學，看得見的魔法<br />
        我們解碼時光在肌膚上的痕跡，將複雜分子式轉化為觸手可及的改變。尖端科技喚醒沉睡細胞，讓細紋、暗沉、鬆弛的焦慮，在鏡中化為驚嘆。
      </p>
      <p class="txt">
        品牌，無聲的承諾<br />
        櫥窗流轉的光澤，是千萬消費者託付的信任。我們搭建的不是貨架，而是連結品質生活方式的橋樑，讓每個合作端口都成為高端美膚體驗的燈塔。
      </p>
      <p class="txt">
        共贏，篤定的答案<br />
        合作夥伴的成長曲線，是品牌的生命線。從物流到終端服務，從視覺到體驗設計，VESCOR構建的是一個共生共榮的生態圈。
      </p>
      <p class="txt">
        此刻，我們向全球發出邀約——選擇VESCOR，與前沿科技同行，引領高端護膚潮流。美力覺醒・時光無懼，帶著對美業的赤誠，與我們共譜市場傳奇。
      </p>
    </div>

    <div class="new-group-layout" @click="handleToast">
      <div class="new-group-layout-content flex-between">
        <div class="new-left-content">
          <h1>中國地區（香港澳門&大陸地區）合作詳情諮詢</h1>
          <p>China (Hong Kong, Macau & Mainland China) cooperation details c</p>
        </div>
        <div class="new-right-content"><i class="icon-file"></i></div>
      </div>
      <div class="new-icons flex-rowc">
        <i class="icon-facebook"></i>
        <i class="icon-ins"></i>
        <i class="icon-cart"></i>
        <i class="icon-youtube"></i>
        <i class="icon-tiktok"></i>
      </div>
    </div>
  </div>
</template>
  <script>
export default {
  name: "CooperationPage",
  data() {
    return {};
  },
  mounted() {},
  methods: {
    handleToast() {
      this.$message.warning({
        message: "即将开放",
        center: true,
        duration: 1500,
        offset: 80,
      });
    },
  },
};
</script>
  <style lang="less">
/deep/.el-message {
  z-index: 1000000000001 !important;
}
.cooperaionPage {
  .image-container {
    display: inline-block; /* 确保容器只占用图片的空间 */
    overflow: hidden; /* 隐藏超出容器的部分 */
  }
  .zoomable-image {
    transition: transform 0.3s ease; /* 添加过渡效果，使放大过程更平滑 */
    cursor: pointer;
    &:hover {
      transform: scale(1.07); /* 鼠标悬停时放大图片 */
    }
  }
  .banner {
    height: 600px;
  }
  .main-title {
    font-family: "SourceHanSerifCN-Medium", sans-serif;
  }
  .txt {
    font-family: "SourceHanSansCN-Light", sans-serif;
  }
  .main-content {
    padding: 110px 310px 192px;
    box-sizing: border-box;
    color: #000000;
    .main-title {
      font-size: 30px;
      font-weight: bold;
      line-height: 42px;
      margin-bottom: 60px;
    }
    .img-box {
      margin-bottom: 90px;
    }
    .txt {
      font-size: 24px;
      margin-bottom: 70px;
      line-height: 40px;
      .highlight {
        font-weight: bold;
      }
    }
  }

  .new-group-layout {
    margin-bottom: 400px;
    .new-group-layout-content {
      width: 1060px;
      height: 160px;
      background: #f9f9f9;
      margin: 0 auto 30px;
      cursor: pointer;
      padding: 0 87px 0 130px;
      box-sizing: border-box;
      .new-left-content {
        h1 {
          font-size: 30px;
          color: #555555;
          position: relative;
          font-family: "SourceHanSerifCN-Medium", sans-serif;
          &::before {
            position: absolute;
            display: inline-block;
            content: "";
            width: 10px;
            height: 30px;
            background: #555555;
            top: 50%;
            transform: translateY(-50%);
            left: -20px;
          }
        }
        p {
          font-size: 18px;
          color: #9a9a9a;
          margin-top: 14px;
        }
      }
      .new-right-content {
        i {
          width: 15px;
          height: 18px;
          background-image: url(https://upload.vwingist.com/melscn/0image/2025/02/4904212986200255044.png);
          background-size: cover;
          display: inline-block;
        }
      }
    }
    .new-icons {
      width: 650px;
      border-top: 1px solid #000000;
      padding-top: 20px;
      margin: auto;
      i {
        display: inline-block;
        cursor: pointer;
        width: 29px;
        height: 29px;
        margin-right: 20px;
      }
      .icon-facebook {
        background-image: url(https://upload.vwingist.com/melscn/0image/2025/02/5098712633813512321.png);
        background-size: cover;
      }
      .icon-ins {
        background-image: url(https://upload.vwingist.com/melscn/0image/2025/02/4853436759718255243.png);
        background-size: cover;
      }
      .icon-cart {
        width: 34px;
        height: 30px;
        background-image: url(https://upload.vwingist.com/melscn/0image/2025/02/4705043591895584161.png);
        background-size: cover;
      }
      .icon-youtube {
        width: 74px;
        height: 29px;
        background-image: url(https://upload.vwingist.com/melscn/0image/2025/02/4698212167918887025.png);
        background-size: cover;
      }
      .icon-tiktok {
        background-image: url(https://upload.vwingist.com/melscn/0image/2025/02/4973589452167469416.png);
        background-size: cover;
        margin-right: 0;
      }
    }
  }
}
</style>